const initParallaxReveal = () => {
  const revealElements = document.querySelectorAll(".parallax");

  
  const revealOnScroll = () => {
    
    if (document.querySelectorAll(".parallax:not(.revealed)").length === 0) {
      window.removeEventListener("scroll", revealOnScroll);
      return;
    }

    const scrollY = window.pageYOffset;
    const windowH = window.innerHeight;

    revealElements.forEach((el) => {
      
      if (!el.classList.contains("revealed")) {
        const rect = el.getBoundingClientRect();
        const top = rect.top + scrollY;

        if (scrollY + windowH > top + 100) {
          el.classList.add("revealed");
        }
      }
    });
  };

  
  window.removeEventListener("scroll", revealOnScroll);
  window.addEventListener("scroll", revealOnScroll);

  
  revealOnScroll();
};




document.addEventListener("DOMContentLoaded", initParallaxReveal);


document.addEventListener("shopify:section:load", initParallaxReveal);


document.addEventListener("shopify:section:unload", () => {
  const revealOnScroll = () => {}; 
  window.removeEventListener("scroll", revealOnScroll);
});